module.exports = __webpack_public_path__ + "img/frame (21).a3a1b06b.jpg";